import QuickBuild from './QuickBuild';

export default QuickBuild;
export { QuickBuild };
